<template>
  <div>
    <!-- ============================================================== -->
    <!-- Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <aside class="left-sidebar">
      <!-- Sidebar scroll-->
      <div class="scroll-sidebar">
        <!-- Sidebar navigation-->
        <nav class="sidebar-nav">
          <ul id="sidebarnav">
            <li class="nav-small-cap">Admin</li>
            <li>
              <a
                class="has-arrow waves-effect waves-dark"
                href="javascript:void(0)"
                aria-expanded="false"
                ><i class="fas fa-map"></i
                ><span class="hide-menu">Location</span></a
              >
              <ul aria-expanded="false" class="collapse">
                <!-- <li><a href="/LocationInfo">Location Info</a></li> -->
                <li>
                  <router-link to="/LocationInfo">Location Info</router-link>
                </li>
                <li><router-link to="/Physicians">Physicians</router-link></li>
                <li id="id_2">
                  <a
                    class="has-arrow waves-effect waves-dark"
                    href="javascript:void(0)"
                    aria-expanded="false"
                    ><span class="hide-menu">Veins Check-in</span></a
                  >
                  <ul aria-expanded="false" class="collapse">
                    <li id="id_2_3">
                      <router-link to="/VisitType">Visit Type</router-link>
                    </li>
                    <li id="id_2_1">
                      <router-link to="/Demo">Demo</router-link>
                    </li>
                    <li id="id_2_2">
                      <router-link to="/Questionnaire"
                        >Questionnaire</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li id="id_1">
                  <a
                    class="has-arrow waves-effect waves-dark"
                    href="javascript:void(0)"
                    aria-expanded="false"
                    ><span class="hide-menu">Veins Tracker</span></a
                  >
                  <ul aria-expanded="false" class="collapse">
                    <li id="id_1_1">
                      <router-link to="/StageAndStep"
                        >Stage And Step</router-link
                      >
                    </li>
                    <li id="id_1_2">
                      <router-link to="/Resource">Resource</router-link>
                    </li>
                  </ul>
                </li>
                <li id="id_3">
                  <router-link to="/Tasks">Tasks To-do</router-link>
                </li>
                <li id="id_3">
                  <router-link to="/smsTemplates">SMS Template</router-link>
                </li>
                <li id="id_4">
                  <router-link to="/emailTemplates">Email Template</router-link>
                </li>
              </ul>
            </li>
            <li id="auditlog">
              <router-link
                class="waves-effect waves-dark"
                to="/auditlogtimeline"
                aria-expanded="false"
                ><i class="fas fa-clipboard"></i
                ><span class="hide-menu">Audit Log</span></router-link
              >
            </li>

            <li>
              <router-link
                class="waves-effect waves-dark"
                to="/Upload"
                aria-expanded="false"
                ><i class="fas fa-upload"></i
                ><span class="hide-menu">Upload</span></router-link
              >
            </li>

            <li>
              <a
                class="waves-effect waves-dark"
                @click="logoutClick()"
                aria-expanded="false"
                ><i class="fas fa-sign-out-alt text-success"></i
                ><span class="hide-menu">Log Out</span></a
              >
            </li>

            <li class="nav-small-cap">Operations</li>
            <li id="ide_11">
              <a
                class="waves-effect waves-dark"
                @click="newTab"
                aria-expanded="false"
                ><i class="far fa-circle text-danger"></i
                ><span class="hide-menu">Veins Check In</span></a
              >
            </li>

            <li id="id_8">
              <a
                class="has-arrow waves-effect waves-dark"
                href="javascript:void(0)"
                aria-expanded="false"
                ><i class="fas fa-tv"></i
                ><span class="hide-menu"
                  >Veins Tracker
                  <!-- <span
                    class="badge badge-pill badge-cyan ml-auto"
                    >4</span
                  > -->
                </span></a
              >

              <ul aria-expanded="false" class="collapse">
                <li id="id_8_1">
                  <router-link to="/StageDisplay">Stage Display </router-link>
                </li>
                <li id="id_8_2" style="display:none">
                  <router-link to="/LobbyDisplay">Lobby Display</router-link>
                  <!-- <router-link to="/StageDisplay1">Stage Display </router-link> -->
                </li>
                <li id="id_8_3">
                  <router-link to="/checkout">Check Out</router-link>
                </li>
              </ul>
            </li>
            <li id="id_5">
              <router-link
                class="waves-effect waves-dark"
                to="/PatientTask"
                aria-expanded="false"
                ><i class="far fa-circle text-danger"></i
                ><span class="hide-menu">Tasks</span></router-link
              >
            </li>

            <li id="id_5">
              <router-link
                class="waves-effect waves-dark"
                to="/PatientPortal"
                aria-expanded="false"
                ><i class="fas fa-clinic-medical text-danger"></i
                ><span class="hide-menu">Patients</span></router-link
              >
            </li>
            <li id="id_5">
              <router-link
                class="waves-effect waves-dark"
                to="/PaymentRequest"
                aria-expanded="false"
                ><i class="fas fa-cash-register"></i
                ><span class="hide-menu">Payments</span></router-link
              >
            </li>
           

            <li class="nav-small-cap">Reports</li>
            <li id="id_7">
              <a
                class="has-arrow waves-effect waves-dark"
                href="javascript:void(0)"
                aria-expanded="false"
                ><i class="fas fa-list"></i>
                <span class="hide-menu"
                  >Reports
                  <!-- <span class="badge badge-pill badge-cyan ml-auto"
                    >4</span
                  > -->
                </span></a
              >
              <ul aria-expanded="false" class="collapse">
                <li id="">
                  <router-link to="/VisitReport"
                    >Visit Type Summary</router-link
                  >
                </li>
                <li id="">
                  <router-link to="/TaskDetail"
                    >Task Detail</router-link
                  >
                </li>
                <li id="">
                  <router-link to="/TaskSummary"
                    >Task Summary</router-link
                  >
                </li>
                <li id="id_7_1">
                  <router-link to="/StatisticReport"
                    >Daily Summary</router-link
                  >
                </li>
                
                <!-- <li id="id_7_2">
                  <router-link to="/WaitTimeReport"
                    >Wait Time Reports</router-link
                  >
                </li>
                <li id="id_7_3">
                  <router-link to="/AdvanceWaitTimeReport"
                    >Advanced Wait Time Reports</router-link
                  >
                </li> -->
                <li id="id_7_4">
                  <router-link to="/DailyReport">Daily Reports</router-link>
                </li>
                <!-- <li id="id_7_5">
                  <router-link to="/StepReport">Step Reports</router-link>
                </li> -->
                <li id="id_7_6">
                  <router-link to="/PhysicianReport"
                    >Physician Reports</router-link
                  >
                </li>
                <!-- <li id="id_7_7">
                  <router-link to="/StaffReport">Staff Reports</router-link>
                </li> -->
                <li id="id_7_8">
                  <router-link to="/PaymentReport">Payment Reports</router-link>
                </li>
                <!-- <li id="id_7_9">
                  <router-link to="/CheckoutReport"
                    >Checkout Reports</router-link
                  >
                </li> -->
                <li id="id_7_9">
                   <router-link to="/newtask"
                    >New task</router-link
                  >
                  </li>
              </ul>
            </li>
          </ul>
        </nav>
        <!-- End Sidebar navigation -->
      </div>
      <!-- End Sidebar scroll-->
    </aside>
    <!-- ============================================================== -->
    <!-- End Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      EmployeeRolesStr: [],
      //loader
      loader: "",
      objID: {
        UserId: "",
        OwnerId: "",
      },
      SubscriptionList: [],
      value: localStorage.OSversion,
      Id: localStorage.xeon,
    };
  }, // end data1()
  methods: {
    newTab() {
      //window.open("https://dev-checkin.veinspracticesolution.com/?index=" + this.value + '&area=' + this.Id, '_blank');
      window.open(
        this.CHECKINSERVER + "/?index=" + this.value + "&area=" + this.Id,
        "_blank"
      );
    },
    whatClick(str) {
      localStorage.what = str;
      this.$router.push({ path: "/Questionnaire" });
    },
    checkInClick() {
      localStorage.from = window.location.href;
      localStorage.icore = "";
      this.$router.push({ path: "/CheckIn" });
      location.reload();
    },

    GetUserSubscritpionList() {
      const myData = this.objID;
      const url = this.SERVER + "/VNSPRAAPI/Checkin/GetUserSubscriptions";
      this.axiosGetUserData(url, myData, 1);
    },
    async axiosGetUserData(Url, myData) {
      console.log("GetData");
      await axios({
        method: "post",
        url: Url,
        data: myData,
      })
        .then((res) => {
          this.SubscriptionList = res.data;
          //debugger;// eslint-disable-line no-debugger
          if (this.SubscriptionList.canVeinsCheckIn == true) {
            console.log("ok");
          } else {
            $("#id_2").hide();
            $("#ide_11").hide();
          }
          if (this.SubscriptionList.canVisitTracker == true) {
            console.log("ok");
          } else {
            $("#id_1").hide();
            $("#id_8").hide();
          }
          if (this.SubscriptionList.canSms == true) {
            console.log("ok");
          } else {
            $("#id_3").hide();
          }
          if (this.SubscriptionList.canEmail == true) {
            console.log("ok");
          } else {
            $("#id_4").hide();
          }
          if (this.SubscriptionList.canPayments == true) {
            console.log("ok");
          } else {
            $("#id_6").hide();
          }
          if (this.SubscriptionList.canPatients == true) {
            console.log("ok");
          } else {
            $("#id_5").hide();
          }

          localStorage.EmployeeRolesStr = "";
          localStorage.EmployeeRolesStr = JSON.stringify(
            this.SubscriptionList.employeeRole
          );
          this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
          this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
          if (this.EmployeeRolesStr.length != 0) {
            this.val1 = this.EmployeeRolesStr.filter((i) => i.name == "Demo");
            this.val2 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Questionnaire"
            );
            this.val5 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Visit Type"
            );
            //
            this.checkVeinsCheck(this.val1, this.val2, this.val5);

            this.val3 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Resource"
            );
            this.val4 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Stage and Step"
            );
            //
            this.veinsTracker(this.val3, this.val4);

            this.val6 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Check Out"
            );
            this.val7 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Lobby Display"
            );
            this.val8 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Stage Display"
            );

            this.veinsTracker1(this.val6, this.val7, this.val8);

            this.val9 = this.EmployeeRolesStr.filter((i) => i.name == "Paid");
            this.val10 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Active Requests"
            );

            this.paymentSet(this.val9, this.val10);

            this.val11 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Statistic Reports"
            );
            this.val12 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Wait Time Reports"
            );
            this.val13 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Advanced Wait Time Reports"
            );
            this.val14 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Daily Reports"
            );
            this.val15 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Step Reports"
            );
            this.val16 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Physician Reports"
            );
            this.val17 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Staff Reports"
            );
            this.val18 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Payment Reports"
            );
            this.val19 = this.EmployeeRolesStr.filter(
              (i) => i.name == "Checkout Reports"
            );

            this.reportSet(
              this.val11,
              this.val12,
              this.val13,
              this.val14,
              this.val15,
              this.val16,
              this.val17,
              this.val18,
              this.val19
            );
          }
        })
        .catch(function (error) {
          alert(error);
        })
        .finally(() => {});
    },

    checkVeinsCheck(val1, val2, val5) {
      if (
        val1[0].canRead == 0 &&
        val2[0].canRead == 0 &&
        val5[0].canRead == 0
      ) {
        $("#id_2").hide();
      } else if (val1[0].canRead == 0) {
        $("#id_2_1").hide();
      } else if (val2[0].canRead == 0) {
        $("#id_2_2").hide();
      } else if (val5[0].canRead == 0) {
        $("#id_2_3").hide();
      }
    },

    veinsTracker(val3, val4) {
      if (val3[0].canRead == 0 && val4[0].canRead == 0) {
        $("#id_1").hide();
      } else if (val4[0].canRead == 0) {
        $("#id_1_1").hide();
      } else if (val3[0].canRead == 0) {
        $("#id_1_2").hide();
      }
    },

    veinsTracker1(val6, val7, val8) {
      if (
        val6[0].canRead == 0 &&
        val7[0].canRead == 0 &&
        val8[0].canRead == 0
      ) {
        $("#id_8").hide();
      } else if (val7[0].canRead == 0) {
        $("#id_8_2").hide();
      } else if (val8[0].canRead == 0) {
        $("#id_8_1").hide();
      } else if (val6[0].canRead == 0) {
        $("#id_8_3").hide();
      }
    },

    paymentSet(val9, val10) {
      if (val10[0].canRead == 0 && val9[0].canRead == 0) {
        $("#id_6").hide();
      } else if (val10[0].canRead == 0) {
        $("#id_6_1").hide();
      } else if (val9[0].canRead == 0) {
        $("#id_6_2").hide();
      }
    },

    reportSet(val11, val12, val13, val14, val15, val16, val17, val18, val19) {
      //debugger;// eslint-disable-line no-debugger;
      if (
        val11[0].canRead == 0 &&
        val12[0].canRead == 0 &&
        val13[0].canRead == 0 &&
        val14[0].canRead == 0 &&
        val15[0].canRead == 0 &&
        val16[0].canRead == 0 &&
        val17[0].canRead == 0 &&
        val18[0].canRead == 0 &&
        val19[0].canRead == 0
      ) {
        $("#id_7").hide();
      } else if (val11[0].canRead == 0) {
        $("#id_7_1").hide();
      } else if (val12[0].canRead == 0) {
        $("#id_7_2").hide();
      } else if (val13[0].canRead == 0) {
        $("#id_7_3").hide();
      } else if (val14[0].canRead == 0) {
        $("#id_7_4").hide();
      } else if (val15[0].canRead == 0) {
        $("#id_7_5").hide();
      } else if (val16[0].canRead == 0) {
        $("#id_7_6").hide();
      } else if (val17[0].canRead == 0) {
        $("#id_7_7").hide();
      } else if (val18[0].canRead == 0) {
        $("#id_7_8").hide();
      } else if (val19[0].canRead == 0) {
        $("#id_7_9").hide();
      }
    },
    logoutClick() {
      this.intDummyComm();
      const url = this.SERVER + `/VNSPRAAPI/Practices/Logout`;
      axios({
        method: "post",
        url: url,
        data: this.dummyComm,
      }).then(() => {});
      
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      localStorage.icore = "";
      //localStorage.xeon = '';
      localStorage.OSversion = "";
      location.href = this.USERSSERVER;
    },
  },
   computed: { 
    ...mapGetters(["getProfileImage","geterLocalStorage"]), 
  },
  
  mounted() {

    if(this.geterLocalStorage){
      if(localStorage.OSversion == undefined){
      localStorage.OSversion = this.geterLocalStorage

    }
const str = localStorage.OSversion;
    //alert(localStorage.OSversion);
    const arr = str.split("<VEINS2021/>");
    this.objID = {
      UserId: arr[0],
      OwnerId: arr[1],
    };
    this.GetUserSubscritpionList();
    }
    
  },
};
</script>
